import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';
import { logger } from '../utils/logger';

export function useCredits() {
  const { user } = useAuth();
  const [credits, setCredits] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkCredits() {
      if (!user) {
        setCredits(0);
        setLoading(false);
        return;
      }

      try {
        const { data: profile, error } = await supabase
          .from('user_profiles')
          .select('available_credits')
          .eq('user_id', user.id)
          .single();

        if (error) throw error;
        setCredits(profile?.available_credits || 0);
      } catch (error) {
        logger.error('Error checking credits:', error);
        setCredits(0);
      } finally {
        setLoading(false);
      }
    }

    checkCredits();
  }, [user]);

  return { credits, loading };
}